// components/industry-templates/EducationEventTemplate.tsx
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { BookOpen, Users, Lightbulb, Award } from 'lucide-react';

export const EducationEventTemplate = ({ structure, theme }: any) => {
  const industryData = structure.industry_data;

  return (
    <div className="space-y-8">
      {/* Target Audience */}
      {industryData?.target_audience && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <Users className="w-6 h-6" style={{ color: theme.primary }} />
              For Educators & Learners
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
              {industryData.target_audience.map((audience: string, idx: number) => (
                <div key={idx} className="p-4 bg-white/5 rounded-lg text-center border border-white/10">
                  <p className="text-white font-medium">{audience}</p>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Workshops */}
      {industryData?.workshops && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <Lightbulb className="w-6 h-6" style={{ color: theme.primary }} />
              Interactive Workshops
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-3">
              {industryData.workshops.map((workshop: any, idx: number) => (
                <div key={idx} className="p-4 bg-white/5 rounded-lg border-l-4" style={{ borderColor: theme.primary }}>
                  <h4 className="font-bold text-white mb-2">{workshop.title}</h4>
                  <div className="flex gap-2 flex-wrap">
                    <Badge style={{ backgroundColor: theme.primary }}>{workshop.duration}</Badge>
                    <Badge variant="outline" className="border-white/20 text-white">{workshop.level}</Badge>
                    {workshop.certificate && (
                      <Badge className="bg-yellow-500 text-black">Certificate Included</Badge>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {/* EdTech Showcase */}
      {industryData?.edtech_showcase && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white">EdTech Innovation Showcase</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-2 gap-4">
              <div className="p-4 bg-white/5 rounded-lg text-center">
                <p className="text-3xl font-bold" style={{ color: theme.primary }}>{industryData.edtech_showcase.startups}</p>
                <p className="text-sm text-slate-400">EdTech Startups</p>
              </div>
              <div className="p-4 bg-white/5 rounded-lg text-center">
                <p className="text-3xl font-bold" style={{ color: theme.primary }}>{industryData.edtech_showcase.product_demos}</p>
                <p className="text-sm text-slate-400">Live Demos</p>
              </div>
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
